//====================================================
//  Function: Basket
//====================================================
function componentDetail() {
  // BASKET IN KOSIK
  if ($(".type-detail").length) {
    if ($(".products-related").length) {
      initProductSection();
    }

    addFlagDetailGroup();

    var priceDiscountDetail = $(".p-info-wrapper .price-save");
    $(".p-detail-info .flags.flags-default").append(priceDiscountDetail);

    $(".p-code-label").text(detailCode);

    $(".product-top .availability-value").append($(".product-top .p-code"));

    var backLink = `
			<span class="back-link" onclick="window.history.back();">
				<svg class="icon-svg icon-arrow-right"><use xlink:href="https://www.365121.myshoptet.${lang}/user/documents/public/images/sprites.svg#icon-arrow-right"></use></svg>
				<div class="back-link__text">${detailBack}</div>
			</span>
		`;

    $(".breadcrumbs-wrapper").append($(backLink));

    addNextParameters();

    setTimeout(() => {
      if ($("#dklabCountdown").length) {
        // var priceInner = $(".p-info-wrapper .p-final-price-wrapper > *");
        $(".p-info-wrapper .p-final-price-wrapper").append(
          '<div class="price-block"></div>'
        );

        if ($(window).width() < 992) {
          $('<div class="price-block-count"></div>').insertAfter(
            ".p-info-wrapper .add-to-cart"
          );
        } else {
          $(".p-info-wrapper .p-final-price-wrapper").append(
            '<div class="price-block-count"></div>'
          );
        }

        $(".p-final-price-wrapper").addClass("is-sale");

        // console.log(priceInner);
        $(".p-info-wrapper .price-block").append(
          $(".p-info-wrapper .p-final-price-wrapper .price-standard")
        );
        $(".p-info-wrapper .price-block").append(
          $(".p-info-wrapper .p-final-price-wrapper .price-final")
        );
        $(".p-info-wrapper .price-block").append(
          $(".p-info-wrapper .p-final-price-wrapper .price-additional")
        );

        $(".price-block-count").append($("#dklabCountdown"));
        $(".price-block-count").append($(".dkLabValidFrom"));
      }
    }, 1000);
  }
}

function initProductSection() {
  var wrapperRelated = `
				<div class="section section-related-products">
					<div class="container">
						<div class="row">
							<div class="col-12 js-related-products">

							</div>
						</div>
					</div>
				</div>`;

  $(wrapperRelated).insertBefore($(".zapati"));

  $(".js-related-products").append($(".products-related-header"));
  $(".js-related-products").append($(".products-related"));

  $(".js-related-products").find(".products .product").addClass("swiper-slide");
  $(".js-related-products").find(".products").addClass("swiper-wrapper");
  $(".js-related-products")
    .find(".products")
    .wrap(
      '<div class="js-slider-group"><div class="swiper-container js-slider-products-detail"></div></div>'
    );
  $(".js-related-products")
    .find(".js-slider-products-detail")
    .append(
      '<div class=" swiper-pagination swiper-pagination-hero js-swiper-pagination"></div>'
    );

  productRelatedSlider();
}

function addFlagDetailGroup() {
  var flagsDetail = $(".p-detail-info .flags.flags-default");
  var productTitleDetail = $(".p-detail-inner-header h1").text();
  if (productTitleDetail.indexOf("120") >= 0) {
    addFlagDetail(flagsDetail, "120");
  }

  if (productTitleDetail.indexOf("150") >= 0) {
    addFlagDetail(flagsDetail, "150");
  }

  if (productTitleDetail.indexOf("180") >= 0) {
    addFlagDetail(flagsDetail, "180");
  }

  if (productTitleDetail.indexOf("210") >= 0) {
    addFlagDetail(flagsDetail, "210");
  }
}

function addFlagDetail(flags, flagText) {
  flags.append(
    '<span class="flag flag-tip"><svg class="icon-svg icon-tree-size"><use xlink:href="https://www.365121.myshoptet.' +
      lang +
      '/user/documents/public/images/sprites.svg#icon-tree-size"></use></svg>' +
      flagText +
      " cm</span>"
  );
}

var descriptionInner;
function addNextParameters() {
  descriptionInner = $(".description-inner");
  var detailParameters = $(".detail-parameters");

  descriptionInner.prepend('<div class="parameters-group"></div>');
  // Size
  if (detailParameters.find("th span").text().indexOf("Veľkosť") >= 0) {
    var sizeText = detailParameters
      .find("th span:contains('Veľkosť')")
      .closest("th")
      .next()
      .text();
    addParameter(sizeText, "Výška", "tree-size");
  }

  // Size
  if (detailParameters.find("th span").text().indexOf("Velikost") >= 0) {
    var sizeText = detailParameters
      .find("th span:contains('Velikost')")
      .closest("th")
      .next()
      .text();
    addParameter(sizeText, "Výška", "tree-size");
  }

  // Weight
  if (detailParameters.find("td").text().indexOf("kg") >= 0) {
    var weightText = detailParameters.find("td:contains('kg')").text();
    addParameter(weightText, "Váha", "tree-weight");
  }

  // Type
  if (detailParameters.find("td").text().indexOf("Smrek") >= 0) {
    var typeText = detailParameters.find("td:contains('Smrek')").text();
    addParameter(typeText, "Strom", "strom");
  }
  // Type
  if (detailParameters.find("td").text().indexOf("Smrk") >= 0) {
    var typeText = detailParameters.find("td:contains('Smrk')").text();
    addParameter(typeText, "Strom", "strom");
  }
  // Type
  if (detailParameters.find("td").text().indexOf("Borovica") >= 0) {
    var typeText = detailParameters.find("td:contains('Borovica')").text();
    addParameter(typeText, "Strom", "strom");
  }
  // Type
  if (detailParameters.find("td").text().indexOf("Borovice") >= 0) {
    var typeText = detailParameters.find("td:contains('Borovice')").text();
    addParameter(typeText, "Strom", "strom");
  }
  // Type
  if (detailParameters.find("td").text().indexOf("Jedla") >= 0) {
    var typeText = detailParameters.find("td:contains('Jedla')").text();
    addParameter(typeText, "Strom", "strom");
  }

  // Type
  if (detailParameters.find("td").text().indexOf("Jedle") >= 0) {
    var typeText = detailParameters.find("td:contains('Jedle')").text();
    addParameter(typeText, "Strom", "strom");
  }

  // Type
  if (detailParameters.find("td").text().indexOf("Jedľa") >= 0) {
    var typeText = detailParameters.find("td:contains('Jedľa')").text();
    addParameter(typeText, "Strom", "strom");
  }

  // Type
  if (detailParameters.find("td").text().indexOf("2D Premium") >= 0) {
    var kindText = detailParameters.find("td:contains('2D Premium')").text();
    addParameter(kindText, "JEHLIČÍ", "jehlici");
  }

  // Type
  if (detailParameters.find("td").text().indexOf("3D Prémium") >= 0) {
    var kindText = detailParameters.find("td:contains('3D Prémium')").text();
    addParameter(kindText, typeOfTree, "jehlici");
  }
  // Type
  if (detailParameters.find("td").text().indexOf("2D Klasické") >= 0) {
    var kindText = detailParameters.find("td:contains('2D Klasické')").text();
    addParameter(kindText, typeOfTree, "jehlici");
  }
  // Type
  if (detailParameters.find("td").text().indexOf("3D Exkluzívne") >= 0) {
    var kindText = detailParameters.find("td:contains('3D Exkluzívne')").text();
    addParameter(kindText, typeOfTree, "jehlici");
  }

  // Type
  if (detailParameters.find("td").text().indexOf("3D Exkluzivní") >= 0) {
    var kindText = detailParameters.find("td:contains('3D Exkluzivní')").text();
    addParameter(kindText, typeOfTree, "jehlici");
  }
  // Type
  if (detailParameters.find("td").text().indexOf("2D Prémium") >= 0) {
    var kindText = detailParameters.find("td:contains('2D Prémium')").text();
    addParameter(kindText, typeOfTree, "jehlici");
  }

  // Type
  if (langCs) {
    if (detailParameters.find("th").text().indexOf("Obsah balenia:") >= 0) {
      detailParameters
        .find("th:contains('Obsah balenia:')")
        .text("Obsah balení:");
    }

    if (detailParameters.find("th").text().indexOf("Dodanie") >= 0) {
      detailParameters.find("th:contains('Dodanie:')").text("Dodání:");
    }
  }
}

function addParameter(text, title, icon) {
  var parameterItem = `
			<div class="parameter__item">
				<div class="parameter__icon">
					<svg class="icon-svg icon-${icon}"><use xlink:href="https://www.365121.myshoptet.${lang}/user/documents/public/images/sprites.svg#icon-${icon}"></use></svg>
				</div>
				<div class="parameter__info-block">
					<div class="parameter__title">${title}</div>
					<div class="parameter__text">${text}</div>
				</div>
			</div>
		`;
  descriptionInner.find(".parameters-group").append($(parameterItem));
}
